import axios from 'axios';
import gql from 'graphql-tag';
import { updateAuthorizationHeader } from '../utils';
import { client } from '../App';

const prefix = 'PROFILE';

export const GET_ME = `${prefix}_GET_ME`;
export const GET_ME_SUCESS = `${prefix}GET_ME_SUCCESS`;
export const GET_ME_ERROR = `${prefix}GET_ME_ERROR`;

function getMeSuccess(payload) {
  return {
    type: GET_ME_SUCESS,
    payload,
  };
}

function getMeError(error) {
  return {
    type: GET_ME_ERROR,
    payload: {
      error,
    },
  };
}

export function getMe() {
  if (!axios.defaults.headers.common['ti-id-token']) {
    updateAuthorizationHeader();
  }
  return dispatch => {
    client
      .query({
        query: gql`
          {
            myAccount {
              id
              userId
              name
              firstName
              lastName
              email
              phone
              logoFileUrl
              features {
                name
                value
              }
            }
          }
        `,
      })
      .then(results => dispatch(getMeSuccess(results)))
      .catch(error => dispatch(getMeError(error)));
  };
}
